import { Injectable, EventEmitter } from '@angular/core';
import { ApiService } from '@xref/ngx';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SearchService {
  searchFor$ = new EventEmitter();

  constructor(
    private api: ApiService
  ) {}

  getSearchResults(search: string, locale: string) {
    return this.api.get(`v1/question/search?term=${search}&language_code=${locale}`).pipe(map(data => data));
  }

  searchFor(keyword: string) {
    this.searchFor$.emit(keyword);
  }
}
